import { render, staticRenderFns } from "./UsersDialogComponent.vue?vue&type=template&id=61897c8a&scoped=true&"
import script from "./UsersDialogComponent.vue?vue&type=script&lang=js&"
export * from "./UsersDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./UsersDialogComponent.vue?vue&type=style&index=0&id=61897c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61897c8a",
  null
  
)

export default component.exports